export const joinStructure = (value: string | string[] | undefined) =>
  Array.isArray(value) ? value.join(',') : value;
